import {
    GET_LIST_SURVEY_BY_RESPONDENT_SUCCESS
  } from '../actions/ActionRespondent'

const INITIAL_STATE = {
	ProfileByIdRespondent: [],
	SurveyBySurveyIdRespondentId: [],
	ListSurveyByRespondentId: [],
}

/**
 * It takes the current state and an action and returns the next state.
 * @param [state] - the current state of the reducer
 * @param [action] - {
 * @returns {
 * 	...state,
 * 	...action.content
 * }
 */
export const reduceRespondent = (state = INITIAL_STATE, action={}) => {
	switch(action.type) { 
		case GET_LIST_SURVEY_BY_RESPONDENT_SUCCESS: 
			return {
				...state,
				...action.content
			};
		default:
			return state;
	}
};